import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToGerman',
})

export class DateToGermanPipe implements PipeTransform {
    transform(value: Date, format?: string) {
      const locale = localStorage.getItem('selectedlanguage') || 'de-DE';
      const timeFormatter = new Intl.DateTimeFormat(locale, {hour: '2-digit', minute: '2-digit', hour12: false });
      const dateFormatter = new Intl.DateTimeFormat(locale, {weekday:  'long', month: 'long', day: 'numeric', year: 'numeric'});
      const date = new Date(value);
      const formattedTime = timeFormatter.format(date).toLowerCase();
      const formattedDate = dateFormatter.format(date).replace(/(\d)([.] )/g, '$1, ').replace(/, (\w)/, ' $1')
      return `${formattedTime} - ${formattedDate}`;
    }


    transformToDownloadModal(value: Date, format?: string) {
      const locale = localStorage.getItem('selectedlanguage') || 'de-DE';
      const timeFormatter = new Intl.DateTimeFormat(locale, {hour: '2-digit', minute: '2-digit', hour12: false });
      const dateFormatter = new Intl.DateTimeFormat(locale, {month: 'long', day: 'numeric', year: 'numeric'});
      const date = new Date(value);
      const formattedTime = timeFormatter.format(date).toLowerCase();

      const formattedDate = dateFormatter.format(date).replace(/(\d)([.] )/g, '$1, ').replace(/, (\w)/, ' $1');
      const formattedDateArray = formattedDate.split(' ');
      const formattedDateToReturn = `${formattedDateArray[1]} ${formattedDateArray[0]}, ${formattedDateArray[2]}`;

      const responseArray = [formattedTime, formattedDateToReturn];
      return responseArray;
    }
}

